import React, { useEffect, useRef } from "react";
import styles from "./PlayerModal.module.css";

export default function PlayerModal({ openItem, onClose, onProgress, onComplete }){
  const videoRef = useRef(null);

  useEffect(()=>{
    if(!openItem) return;
    const v = videoRef.current;
    if(!v) return;
    const onTime = () => {
      onProgress(openItem.id, Math.floor(v.currentTime||0), Math.floor(v.duration|| (openItem?.duration || 1)));
    };
    const onEnded = () => { onComplete(openItem.id, openItem?.duration||1); };
    v.addEventListener('timeupdate', onTime);
    v.addEventListener('ended', onEnded);
    return ()=>{
      v.removeEventListener('timeupdate', onTime);
      v.removeEventListener('ended', onEnded);
    };
  },[openItem, onProgress, onComplete]);

  if(!openItem) return null;
  return (
    <div className={styles.modal} role="dialog" aria-modal="true" aria-label={`Playing ${openItem.title}`} onClick={(e)=>{ if(e.target.classList.contains(styles.modal)) onClose(); }}>
      <div className={styles.player}>
        <div className={styles.bar}>
          <h3 className={styles.title}>▶ {openItem.title}</h3>
          <button className={styles.close} onClick={onClose}>Close ✖</button>
        </div>
        <video ref={videoRef} className={styles.video} src={openItem.url} controls autoPlay playsInline />
      </div>
    </div>
  );
}
